/**
 * `tel:`-Link für die Tap-to-Call-CTA der Fehler-Screens.
 *
 * Erzeugt eine normalisierte `tel:`-URL (Leerzeichen und führende Zeichen
 * entfernt), behält die Anzeige in lesbarer Form.
 */
interface PhoneLinkProps {
  readonly phoneNumber: string;
  readonly label: string;
  readonly className?: string;
}

function toTelHref(phoneNumber: string): string {
  const compact = phoneNumber.replace(/[^+0-9]/g, '');
  return `tel:${compact}`;
}

export function PhoneLink(props: PhoneLinkProps): JSX.Element {
  const { phoneNumber, label, className } = props;
  const baseClassName =
    'inline-flex min-h-touch min-w-touch items-center justify-center rounded-2xl bg-brand px-4 py-2 font-semibold text-brand-foreground shadow-md shadow-brand/20 transition-all hover:brightness-110 active:scale-[0.99] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand';
  const composedClassName =
    className === undefined ? baseClassName : `${baseClassName} ${className}`;
  return (
    <a href={toTelHref(phoneNumber)} aria-label={label} className={composedClassName}>
      {label}
      <span aria-hidden="true" className="ml-2 text-sm opacity-80">
        {phoneNumber}
      </span>
    </a>
  );
}
